import { whatsappHref } from "@/mocks/modalConfig";

export default function WhatsAppFloat() {
  return (
    <a
      href={whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Consultar por WhatsApp"
      title="Consultar por WhatsApp"
      className="group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[80] flex items-center h-14 md:h-16 px-2.5 md:px-2 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/25 hover:bg-[#1EBE5A] transition-all duration-300 cursor-pointer"
    >
      <span className="relative flex items-center justify-center w-9 h-9 md:w-12 md:h-12 flex-shrink-0">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping pointer-events-none" />
        <i className="relative ri-whatsapp-line text-3xl md:text-4xl" />
      </span>

      <span className="max-w-0 overflow-hidden opacity-0 whitespace-nowrap font-body font-semibold text-sm md:text-base transition-all duration-300 group-hover:max-w-[240px] group-hover:opacity-100 group-hover:ml-2.5">
        Consultar por WhatsApp
      </span>
    </a>
  );
}